import { FC, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { OptionsMenuItem } from '@/common/components/OptionsMenuItem/OptionsMenuItem';
import { MenuToggleContext } from '@/base/layouts/contexts/MenuToggleContext';
import { Box, BoxProps } from '@mui/material';
import menuItems from './items';
import { useSearchStore } from '@/common/stores/searchStore';
import { usePaginationStore } from '@/common/stores/paginationStore';
interface MainMenuItemsProps {
  wrapperStyles?: BoxProps['sx'];
}

export const MainMenuItems: FC<MainMenuItemsProps> = ({ wrapperStyles }) => {
  const router = useRouter();
  const { reset: clearSearchStore } = useSearchStore();
  const { resetQueryParams } = usePaginationStore();

  // clear all the needed stores when changing the path
  const clearStores = () => {
    clearSearchStore();
    resetQueryParams();
    router.query = {};
  };

  const { closeMenu } = useContext(MenuToggleContext);
  const handlePathChange = () => {
    if (!router.isReady) {
      return;
    }
  };

  useEffect(handlePathChange, [router.isReady, router.asPath]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={0.9}
      pt={1.8}
      sx={{ ...wrapperStyles }}
    >
      {menuItems.map((item, index) => {
        const active =
          router.pathname.includes(item.link) || router.pathname === item.link;

        const handleOnClick = () => {
          closeMenu();
          clearStores();
        };

        return (
          <OptionsMenuItem
            key={index}
            link={item.link}
            handleOnClick={handleOnClick}
            active={active}
            textStyles={{ fontWeight: 600 }}
            {...item}
          />
        );
      })}
    </Box>
  );
};
